import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { createAsyncThunkSafe } from '@/state/_base/createAsyncThunkSafe';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { assert_type_array, assert_type_string } from '@shared/asserts/utils_asserts';
import { DTO_REQUEST__grid2d_chunk_load_cells } from '@shared/dto/grid2d/_requests/DTO_REQUEST__grid2d_chunk_load_cells';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { STATE__grid2d } from '../STATE__grid2d';

export const REMOTE__grid2d_chunk_load_cells = createAsyncThunkSafe<string[], DTO_REQUEST__grid2d_chunk_load_cells>(
  ENUM__network_event_client_to_server.GRID2D_CHUNK_LOAD_CELLS,
  async (request): Promise<string[]> => {
    await send_to_server(ENUM__network_event_client_to_server.GRID2D_CHUNK_LOAD_CELLS, request);

    return request.grid2d_chunk_ids;
  },
);

export function INIT_REMOTE__grid2d_chunk_load_cells(builder: ActionReducerMapBuilder<STATE__grid2d>) {
  builder
    .addCase(REMOTE__grid2d_chunk_load_cells.pending, (state, action) => {
      let request = action.meta.arg;

      for (let grid2d_chunk_id of request.grid2d_chunk_ids) {
        state.grid2d_chunk_cells_loading_in_progress.add(grid2d_chunk_id);

        //need to force rerender
        state.grid2d_chunk_cells_loading_in_progress = new Set(state.grid2d_chunk_cells_loading_in_progress);
      }
    })
    .addCase(REMOTE__grid2d_chunk_load_cells.rejected, (state, action) => {})
    .addCase(REMOTE__grid2d_chunk_load_cells.fulfilled, (state, action: PayloadAction<string[]>) => {
      assert_type_array(action.payload);

      for (let grid2d_chunk_id of action.payload) {
        assert_type_string(grid2d_chunk_id);
        state.grid2d_chunk_cells_loading_in_progress.delete(grid2d_chunk_id);
      }

      //need to force rerender
      state.grid2d_chunk_cells_loading_in_progress = new Set(state.grid2d_loading_in_progress);
    });
}
